<!--P036-->
<template>
  <div class="div_content">
    <div class="cs_margin_top_sm ui_hierarchy">
      <div class="cs_cursor_pointer ui_txt_hierarchy">配方维护</div>
    </div>
    <!--查询栏-->
    <div class="cs_margin_top div_search bg_search cs_padding">
      <div class="cs_title_primary cs_text_default type_info_search">货品</div>
      <input v-model="search.name" class="cs_input cs_radius_lg edtxt_info_search" placeholder="请输入">
      <button class="ui_btn_search_yellow btn_search" type="button" @click="btnSearch">查询</button>
    </div>
    <!--表格-->
    <div class="cs_margin_top_sm div_search_result cs_padding_top_lg">
      <div class="div_table">
        <table class="cs_table cs_td_divider_none" width="100%">
          <thead>
          <tr>
            <th width="40px">序号</th>
            <th width="320px">货品编号</th>
            <th width="480px">货品名称</th>
            <th width="241px">配方数量</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(item,index) in orderList">
            <td>{{index+1}}</td>
            <td><a @click="$router.push({name:'BomDetail', query: {id:item.id,num:item.materialNum,name:item.materialName,unit:item.dcStockUnit}})">{{item.materialNum}}</a></td>
            <td>{{item.materialName}}</td>
            <td>{{item.bomCounts}}</td>
          </tr>
          <tr v-for="(item,index) in (PAGE_SIZE-orderList.length)">
            <td></td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
          </tbody>
        </table>
      </div>
      <div class="div_page_download">
        <!--上一页-->
        <button v-show="search.pagination>1" @click="showList(search.pagination < 2?1:search.pagination-1)"
                class="btn_page_up" type="button">
        </button>
        <button v-show="search.pagination<=1" class="btn_page_up_disable" type="button"></button>
        <div class="current_page">{{search.pagination}}</div>
        <div class="oblique_line">/</div>
        <div class="total_page">{{search.totalPage}}</div>
        <!--下一页-->
        <button v-show="search.pagination!==search.totalPage" @click="showList(search.pagination+1)" class="btn_page_down" type="button"></button>
        <button v-show="search.pagination===search.totalPage" class="btn_page_down_disable" type="button"></button>
        <div @click="jump()" class="type_page_jump">跳转至</div>
        <input v-model="search.pageJump" class="txt_page_jump" type="text"
               @keyup="checkPositiveInt($event)" @blur="search.pageJump=checkPositiveInt($event)">
      </div>
    </div>
    <div class="div_bottom"></div>
  </div>
</template>

<script>
  import {Page, PAGE_SIZE} from "../../assets/utils/constants"
  import XLSX from 'xlsx'
  import StorageConst from "../../assets/utils/StorageConst";
  export default {
    name: "BomManage",
    data: function () {
      return {
        search: {
          name: this.getStoreItem(StorageConst.LOCAL_PAGE_LIST.BOM_MANAGE,"name", ""),
          pageJump: "",
          totalPage: "",
          pagination: this.getStoreItem(StorageConst.LOCAL_PAGE_LIST.BOM_MANAGE,"pagination", 1)
        },
        orderList: [],
        PAGE_SIZE: PAGE_SIZE,
      }
    },
    created: function () {
      this.showList(this.search.pagination);
    },
    mounted: function() {
    },
    methods: {
      showList(pagination) {
        this.$ajax.bom.listProduceMaterial.bind(this)(this.search.name, new Page(PAGE_SIZE, pagination), (data) => {
          //显示列表
          this.search.totalPage = data.data.totalPage;
          this.search.pagination = data.data.pagination;
          this.orderList = data.data.list;
          this.setStoreItem(StorageConst.LOCAL_PAGE_LIST.BOM_MANAGE, JSON.stringify(this.search));
        }, (data) => {
        }, true)
      },
      btnSearch(){
        this.showList(1);
      },

      jump() {
        if (!this.isEmpty(this.search.pageJump)) {
          if(this.search.pageJump>this.search.totalPage){
            this.showList(this.search.totalPage);
          }else {
            this.showList(this.search.pageJump);
          }
        }
      },
    },
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/page/bom/BomManage.vue